<template>
    <div
        class="p-page | l-wrapper"
    >
        <Header>
            <div class="l-header__content">

                <nav class="l-nav l-nav--header">
                    <ul class="l-nav__list">
                        <li
                            v-for="item in navigation"
                            :key="item.path"
                            class="l-nav__item"
                        >

                            <router-link
                                :key="item.slug"
                                :to="item.path"
                                class="l-nav__link"
                                exact
                            >
                                {{ item.title }}
                                <span></span>
                            </router-link>
                        </li>

                        <li
                            v-if="!$store.getters.isLogin"
                            class="l-nav__item"
                        >
                            <router-link
                                :to="ROUTES.MODAL.AUTH.REGISTER"
                                class="l-nav__link"
                            >
                                Inscription
                                <span></span>
                            </router-link>
                        </li>
                    </ul>
                </nav>


                <Link
                    v-if="$store.getters.isLogin"
                    :href="ROUTES.ADMIN.ROOT"
                    label="Mon Compte"
                    class="l-header__connect"
                    iconBefore="user"
                >
                </Link>
                <Link
                    v-else
                    :href="ROUTES.MODAL.AUTH.LOGIN"
                    label="Connexion"
                    class="l-header__connect"
                    iconBefore="user"
                ></Link>

            </div>


            <Link
                label="Débuter une évaluation"
                :href="ROUTES.MODAL.CREATE_QUIZ"
                class="l-header__cta"
                iconAfter="arrow-right"
            ></Link>
        </Header>

        <!--
        <span
            ref="popup"
            class="o-popup"
            @click="removePopup"
        >
            <Icon
                icon="cross"
            ></Icon>
            <span class="o-popup__inner">
                <Rounded
                    size="xs"
                >
                    À venir en octobre
                </Rounded>
                <p class="t-s">Évaluation de votre indice d'écoresponsabilité en ligne</p>
            </span>
        </span>
        -->

        <main class="l-main">
            <slot></slot>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from 'templates/layout/Header';
import Footer from 'templates/layout/Footer';
import Icon from 'templates/objects/Icon';
import Rounded from 'templates/objects/Rounded';
import Link from 'templates/objects/Link';

export default {
    components: {
        Link,
        Header,
        Footer,
        Icon,
        Rounded,
    },
    data() {
        return {
            navigation: JSON.parse(JSON.stringify(window.__initialData__.headerNodes)),
        };
    },
    //    methods: {
    //        removePopup(e) {
    //            if (!this.$refs.popup) return;
    //            this.$refs.popup.classList.add('is-hidden');
    //            setTimeout(() => {
    //                this.$refs.popup.parentNode.removeChild(this.$refs.popup);
    //            }, 800);
    //        },
    //    },

};
</script>

<!--
<style lang="scss" scoped>

    .o-popup {
        z-index: 400;
        position: fixed;
        bottom: 0;
        right: 0;
        display: block;
        width: 100%;
        padding: 1em 2.5em;
        background-color: $color-light;
        box-shadow: $shadow;
        cursor: pointer;

        .o-popup__inner {
            display: block;
        }

        .o-icon {
            position: absolute;
            top: 1.5em;
            left: 1em;
        }

        .o-rounded {
            margin-bottom: .75em;
            font-size: .75em;
            text-transform: uppercase;
            border-radius: .5em;
            background-color: $color-yellow;
        }

        &.is-hidden {
            transform: translate(0, 100%);
            transition: transform .6s $in-out-quad .2s;

            .o-icon {
                opacity: 0;
                transform: scale(0);
                transition: opacity .2s $in-sine, transform .2s $in-expo;
            }

            .o-popup__inner {
                opacity: 0;
                transition: opacity .3s $in-sine;
            }
        }

        @screen sm {
            max-width: 17em;
            bottom: 60%;
            border-top-left-radius: $radius;
            border-bottom-left-radius: $radius;

            &.is-hidden {
                transform: translate(100%, 0);
            }
        }
    }
</style>
-->
